/*eslint-disable*/
export default {
    inserted(el) {
        arguments[1].value === 0 && el.focus();
    },
}
